// Platform-agnostic development check
const isDev = (() => {
  // Try direct access for Vite (when bundled)
  try {
    // @ts-ignore - This will work in Vite but not in TypeScript compilation
    return import.meta.env.DEV;
  } catch {
    // fallthrough for non-Vite environments
  }
  
  // React Native - __DEV__ is standard global
  if (typeof globalThis !== 'undefined' && '__DEV__' in globalThis) {
    return (globalThis as any).__DEV__;
  }
  
  // Node.js fallback
  return process.env.NODE_ENV === 'development';
})();

export const API_CONFIG = {
  BASE_URL: isDev ? 'http://localhost:8080' : 'https://platform-certi-production.up.railway.app',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/auth/login',
      REGISTER: '/api/auth/register',
      REFRESH: '/api/auth/refresh',
      LOGOUT: '/api/auth/logout',
      FORGOT_PASSWORD: '/api/auth/forgot-password',
      RESET_PASSWORD: '/api/auth/reset-password',
    },
    USER: {
      PROFILE: '/api/v1/users/{userId}/profile',
      UPDATE_PROFILE: '/api/v1/users/{userId}/profile',
      UPDATE_EMAIL: '/api/v1/users/{userId}/email',
      UPDATE_PASSWORD: '/api/v1/users/{userId}/password',
    },
    LISTINGS: {
      PUBLIC: '/api/public/listings',
      PUBLIC_BY_SLUG: '/api/public/listings/{slug}',
      ADMIN: '/api/admin/listings',
      ADMIN_BY_ID: '/api/admin/listings/{id}',
      ADMIN_UPDATE_STATUS: '/api/admin/listings/{id}/status',
      MEDIA_UPLOAD: '/api/admin/listings/media/upload',
      ATTACH_MEDIA: '/api/admin/listings/{id}/media',
    },
  },
  TIMEOUT: 10000, // 10 seconds
};

export const createApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};